import { combineReducers } from 'redux';

import doctor from './doctor/reducer';
import conversation from './conversation/reducer';
import conversationActive from './conversationActive/reducer';
import messages from './messages/reducer';
import allMedia from './allMedia/reducer';
import contextMenu from './contextMenu/reducer';
import consultHistory from './consultHistory/reducer';
import typing from './typing/reducer';
import consultFee from './consultFee/reducer';
import messageSearch from './messageSearch/reducer';
import consults from './consult/reducer';
import healthSummary from './healthSummary/reducer';
import configs from './configs/reducer';
import emc from './emc/reducer';
import prescription from './prescription/reducer';
import pharmacy from './pharmacy/reducer';
import commons from './commons/reducer';
import invitation from './invitation/reducer';
import users from './users/reducer';
import pos from './pos/reducer';
import video from './video/reducer';
import memo from './memo/reducer';
import referralMemo from './referralMemo/reducer';
import file from './file/reducer';

export default combineReducers({
  doctor,
  conversation,
  conversationActive,
  messages,
  allMedia,
  contextMenu,
  consultHistory,
  typing,
  consultFee,
  messageSearch,
  consults,
  healthSummary,
  configs,
  emc,
  prescription,
  pharmacy,
  commons,
  invitation,
  users,
  pos,
  video,
  memo,
  referralMemo,
  file,
});
